import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"

// Por debajo de este umbral la píldora avisa en ámbar
const WARNING_SECONDS = 5 * 60

const dosDigitos = value => String(value).padStart(2, "0")

/**
 * Cuenta atrás de la ventana diaria de captura.
 *
 * No se reutiliza `components/Common/Timer`: aquel lleva cableado
 * `text-danger float-end` —incompatible con la cabecera del diseño— y programa
 * un `setTimeout` nuevo en cada render sin cancelar el anterior.
 */
const AvailabilityCountdown = ({ secondsLeft, isExpired, onExpire }) => {
  const [restante, setRestante] = useState(secondsLeft ?? 0)
  const avisado = useRef(false)

  // el valor inicial llega de la API, así que se resiembra al recibirlo
  useEffect(() => {
    if (secondsLeft === null || secondsLeft === undefined) return
    setRestante(secondsLeft)
    avisado.current = false
  }, [secondsLeft])

  useEffect(() => {
    if (isExpired || restante <= 0) return undefined
    const intervalo = setInterval(() => setRestante(previo => previo - 1), 1000)
    return () => clearInterval(intervalo)
  }, [isExpired, restante])

  useEffect(() => {
    if (isExpired || restante > 0 || avisado.current) return
    avisado.current = true
    onExpire()
  }, [restante, isExpired, onExpire])

  if (secondsLeft === null || secondsLeft === undefined) return null

  if (isExpired || restante <= 0) {
    return (
      <span className="av-time is-off">
        <i className="bx bx-time-five" />
        Fuera de tiempo
      </span>
    )
  }

  return (
    <span className={`av-time${restante <= WARNING_SECONDS ? " is-warning" : ""}`}>
      <i className="bx bx-time-five" />
      {dosDigitos(Math.floor(restante / 60))} min {dosDigitos(restante % 60)} seg
    </span>
  )
}

AvailabilityCountdown.propTypes = {
  secondsLeft: PropTypes.number,
  isExpired: PropTypes.bool,
  onExpire: PropTypes.func.isRequired,
}

export default AvailabilityCountdown
